import { Box } from "@mui/material";
import { keyframes, useTheme } from "@mui/material/styles";

const toothDash = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 170px, 200px;
    stroke-dashoffset: -45px;
  }
  100% {
    stroke-dasharray: 170px, 200px;
    stroke-dashoffset: -140px;
  }
`;

export default function ToothSpinner({
  size = 48,
  thickness = 3.5,
  speed = 1.5,
}) {
  const theme = useTheme();

  return (
    <Box
      role="progressbar"
      aria-label="Loading"
      sx={{
        display: "inline-flex",
        width: size,
        height: size,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 64 64"
        sx={{
          display: "block",
          width: size,
          height: size,
          overflow: "visible",
        }}
      >
        <Box
          component="path"
          d="M32 8
             C25 8, 19 10.5, 15.5 15
             C11.5 20.2, 11 27.2, 13 34
             C14.4 38.8, 16.4 43.8, 18.2 48.2
             C19.2 50.8, 20.2 53.2, 21 55.2
             C21.6 56.8, 22.9 58, 24.4 58
             C26.2 58, 27.5 56.6, 28 54.8
             L29.6 47.8
             C30 46, 31 45, 32 45
             C33 45, 34 46, 34.4 47.8
             L36 54.8
             C36.5 56.6, 37.8 58, 39.6 58
             C41.1 58, 42.4 56.8, 43 55.2
             C43.8 53.2, 44.8 50.8, 45.8 48.2
             C47.6 43.8, 49.6 38.8, 51 34
             C53 27.2, 52.5 20.2, 48.5 15
             C45 10.5, 39 8, 32 8Z"
          pathLength={200}
          sx={{
            fill: "none",
            stroke: theme.palette.primary.main,
            strokeWidth: thickness,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "6px, 200px",
            strokeDashoffset: 0,
            animation: `${toothDash} ${speed}s cubic-bezier(0.4, 0, 0.2, 1) infinite`,
            willChange: "stroke-dasharray, stroke-dashoffset",
          }}
        />
      </Box>
    </Box>
  );
}